/**
 * Contract Manager API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import {HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse} from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {UpdateRequest} from '../model/updateRequest';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class UpdateRequestService {

  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  protected basePath = 'https://localhost';

  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * Retrieves the collection of all Bw Etrees
   *
   * @param bwEtree
   * @param bwEtree2
   * @param status
   * @param status2
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getUpdateRequestCollection(bwEtree?: string, bwEtree2?: Array<string>, status?: string, status2?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<UpdateRequest>>;

  public getUpdateRequestCollection(bwEtree?: string, bwEtree2?: Array<string>, status?: string, status2?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<UpdateRequest>>>;

  public getUpdateRequestCollection(bwEtree?: string, bwEtree2?: Array<string>, status?: string, status2?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<UpdateRequest>>>;

  public getUpdateRequestCollection(bwEtree?: string, bwEtree2?: Array<string>, status?: string, status2?: Array<string>, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (bwEtree !== undefined) {
      queryParameters = queryParameters.set('bwEtree', <any>bwEtree);
    }
    if (bwEtree2) {
      bwEtree2.forEach((element) => {
        queryParameters = queryParameters.append('bwEtree[]', <any>element);
      });
    }
    if (status !== undefined) {
      queryParameters = queryParameters.set('status', <any>status);
    }
    if (status2) {
      status2.forEach((element) => {
        queryParameters = queryParameters.append('status[]', <any>element);
      });
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/ld+json',
      'application/hal+json',
      'application/json',
      'text/html'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [];

    return this.httpClient.get<Array<UpdateRequest>>(`${this.basePath}/api/update_requests`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Retrieve one etree
   *
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getUpdateRequestItem(id: string, observe?: 'body', reportProgress?: boolean): Observable<UpdateRequest>;

  public getUpdateRequestItem(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UpdateRequest>>;

  public getUpdateRequestItem(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UpdateRequest>>;

  public getUpdateRequestItem(id: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getUpdateRequestItem.');
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/ld+json',
      'application/hal+json',
      'application/json',
      'text/html'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [];

    return this.httpClient.get<UpdateRequest>(`${this.basePath}/api/update_requests/${encodeURIComponent(String(id))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Create an update request
   *
   * @param updateRequest The new UpdateRequest resource
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public postUpdateRequestCollection(updateRequest?: UpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<UpdateRequest>;

  public postUpdateRequestCollection(updateRequest?: UpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UpdateRequest>>;

  public postUpdateRequestCollection(updateRequest?: UpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UpdateRequest>>;

  public postUpdateRequestCollection(updateRequest?: UpdateRequest, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/ld+json',
      'application/hal+json',
      'application/json',
      'text/html'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
      'application/ld+json',
      'application/hal+json',
      'application/json',
      'text/html'
    ];
    let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post<UpdateRequest>(`${this.basePath}/api/update_requests`,
      updateRequest,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Retrieve one etree
   *
   * @param id
   * @param updateRequest The updated UpdateRequest resource
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public putUpdateRequestItem(id: string, updateRequest?: UpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<UpdateRequest>;

  public putUpdateRequestItem(id: string, updateRequest?: UpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UpdateRequest>>;

  public putUpdateRequestItem(id: string, updateRequest?: UpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UpdateRequest>>;

  public putUpdateRequestItem(id: string, updateRequest?: UpdateRequest, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling putUpdateRequestItem.');
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/ld+json',
      'application/hal+json',
      'application/json',
      'text/html'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
      'application/ld+json',
      'application/hal+json',
      'application/json',
      'text/html'
    ];
    let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.put<UpdateRequest>(`${this.basePath}/api/update_requests/${encodeURIComponent(String(id))}`,
      updateRequest,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (let consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

}
